document.addEventListener('DOMContentLoaded', function () {
  const isMobile = window.matchMedia('(max-width: 768px)').matches;
  const sections = document.querySelectorAll('[data-enable-zoom="true"]');

  sections.forEach(section => {
    const images = section.querySelectorAll('.text-column__image');

    images.forEach(image => {
      const img = image.querySelector('img');
      if (!img) return;

      if (isMobile) {
        // Mobile: Wrap image in link for Shopify's native lightbox
        if (!image.querySelector('a')) {
          const imgSrc = img.getAttribute('src').replace(/_(\d+x\d+|x\d+|\d+x)\./, '.').replace(/(\.jpg|\.jpeg|\.png|\.webp)(\?.*)?(.*)?$/, '$1');
          const anchor = document.createElement('a');
          anchor.setAttribute('href', imgSrc);
          anchor.setAttribute('data-media-id', 'mobile-lightbox-' + Math.random().toString(36).substring(2));
          anchor.className = 'lightbox-link';
          img.parentNode.insertBefore(anchor, img);
          anchor.appendChild(img);
        }
        return;
      }

      // Desktop magnifier logic
      const magnifier = document.createElement('div');
      magnifier.className = 'magnifier';
      image.appendChild(magnifier);

      let imgSrc = img.getAttribute('src');
      imgSrc = imgSrc.replace(/_(\d+x\d+|x\d+|\d+x)\./, '.').replace(/(\.jpg|\.jpeg|\.png|\.webp)(\?.*)?(.*)?$/, '$1');

      const zoomLevel = .43; // Adjust zoom level as needed
      const magnifierSize = { width: 300, height: 250 };

      const moveMagnifier = (e) => {
        const rect = image.getBoundingClientRect();
        const x = e.clientX - rect.left;
        const y = e.clientY - rect.top;

        if (x >= 0 && y >= 0 && x <= rect.width && y <= rect.height) {
          magnifier.style.display = 'block';
          magnifier.style.left = `${Math.max(0, Math.min(x - magnifierSize.width / 2, rect.width - magnifierSize.width))}px`;
          magnifier.style.top = `${Math.max(0, Math.min(y - magnifierSize.height / 2, rect.height - magnifierSize.height))}px`;

          const bgX = -((x / rect.width) * img.naturalWidth * zoomLevel - magnifierSize.width / 2);
          const bgY = -((y / rect.height) * img.naturalHeight * zoomLevel - magnifierSize.height / 2);

          magnifier.style.backgroundImage = `url('${imgSrc}')`;
          magnifier.style.backgroundSize = `${img.naturalWidth * zoomLevel}px ${img.naturalHeight * zoomLevel}px`;
          magnifier.style.backgroundPosition = `${bgX}px ${bgY}px`;
        } else {
          magnifier.style.display = 'none';
        }
      };

      image.addEventListener('mousemove', moveMagnifier);
      image.addEventListener('mouseleave', () => magnifier.style.display = 'none');
    });
  });
});
